import React, { Component } from "react";
import { InputRun } from "../../../shared/input/InputRun.jsx";

class SearchRutForm extends Component {
    constructor(props){
        super(props);
        this.state = {rut: '', dv: '', btnDisabled: false};
        
        this.onRutChange = (rut, dv) => {
            this.setState({rut});
            this.setState({dv});
        };
        
        this.searchingFiles = (rut) => {
            if (this.state.rut === '') return;
            this.setState({btnDisabled: true});
            props.getFiles(rut)
                .then(this.setState({btnDisabled: false}))
                .catch(error => {
                    console.log(error);
                    this.setState({btnDisabled: false})
                })
        };
    }

    render(){
        return (
            <div className="input-group">
                <InputRun
                    onPressEnter={this.searchingFiles}
                    onRUNChange={this.onRutChange}
                    className="form-control"
                />
                <span className="input-group-btn">
                    <button
                        type="button"
                        className="btn btn-default"
                        disabled
                    >
                        {this.state.dv !== ""? this.state.dv : "DV" }
                     </button>   
                    <button 
                        onClick={() => this.searchingFiles(this.state.rut)} 
                        type="button"
                        className="btn btn-default" 
                        disabled={this.state.btnDisabled}
                     >
                        Buscar
                    </button>
                </span>
            </div>
        )
    };
}

export default SearchRutForm;


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/components/SearchRutForm.jsx